import React, { useState } from "react";
import Checkbox from "./Checkbox";
export default function FilterOverlayItem({ title, id, onChange, checked }) {
  return (
    <div className="filteritem">
      <Checkbox label={title} value={checked} id={id} onChange={onChange} />
    </div>
  );
}
